export default __webpack_public_path__ + "static/media/kristina_savova_m.b0822d54.jpg";